// src/components/Login.js
import React, { useState } from "react";
import { signInWithEmailAndPassword, signOut } from "firebase/auth";
import {
  Container,
  Paper,
  TextField,
  Button,
  Typography,
} from "@mui/material";
import { auth } from "../firebase-config";

const Login = ({ onUnverifiedAttempt }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  const handleLogin = async (event) => {
    event.preventDefault();
    setErrorMsg("");
    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );
      const user = userCredential.user;
      
      // If the email is not verified, trigger the callback and sign out.
      if (!user.emailVerified) {
        if (onUnverifiedAttempt) onUnverifiedAttempt();
        await signOut(auth);
        return;
      }
      
      // Continue normally if verified.
      // (Auth Context handles navigation on a successful login.)
    } catch (error) {
      console.error("Login failed:", error);
      setErrorMsg("Login failed. Please check your credentials and try again.");
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 4 }}>
      <Paper elevation={3} sx={{ p: 3 }}>
        <Typography variant="h5" gutterBottom>
          Login
        </Typography>
        {errorMsg && (
          <Typography variant="body1" color="error">
            {errorMsg}
          </Typography>
        )}
        <form onSubmit={handleLogin}>
          <TextField
            label="Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            fullWidth
            margin="normal"
            InputLabelProps={{
              style: {
                whiteSpace: "normal",  // allow wrapping
                overflow: "visible",   // ensures text is not clipped
              },
            }}
          />
          <TextField
            label="Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            fullWidth
            margin="normal"
            InputLabelProps={{
              style: {
                whiteSpace: "normal",
                overflow: "visible",
              },
            }}
          />
          <Button variant="contained" color="primary" type="submit" sx={{ mt: 2 }}>
            Login
          </Button>
        </form>
      </Paper>
    </Container>
  );
};

export default Login;